import {Component, h, Fragment} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {fetchAcademicPrograms, fetchCandidate, changeCandidateStatus, clearCandidate} from "../_rx/jobs/actions";
import {AcademicProgram, CompanyApplicationItem} from "../_api";
import {C, Card, CF, E, F, FR, R} from "../_common/layout";
import {Link} from "react-router-dom";
import Dropdown from "../_common/components/dropdown";
import {t} from "../_i18n";
import {formatDDMMYYYY, rndStr} from "../_common/common";
import DropdownButton from "../_common/components/dropdownButton";
import {ModalLink} from "../_common/components/modal";
import InfoModal from "./components/infoModal";
import QuestionaryModal from "./components/questionaryModal"
import LetterModal from "./components/letterModal"
import {ButtonApplied, ButtonAcepted, ButtonSelected, ButtonDiscard} from "./components/buttons";
import {Helmet} from "react-helmet";
import Badge from "../_common/components/Badge";


type reactProps = {
    match: any,
    fixtures: {academic_programs: AcademicProgram[]},
    fetchAcademicPrograms: typeof fetchAcademicPrograms,
    fetchCandidate: typeof fetchCandidate,
    changeCandidateStatus: typeof changeCandidateStatus,
    clearCandidate: typeof clearCandidate,
    candidateReducer: any
}

type reactState = {
    idModalInfo: string,
    idModalQuestionary: string,
    idModalLetter: string,
}

const statuses : {[key:string]: string} = {
    "applied": t("Por leer"),
    "accepted": t("En proceso"),
    "selected": t("Finalista"),
    "discarded": t("Descartado")
}

const status_const = {
    applied: "applied",
    accepted: "accepted",
    selected: "selected",
    discarded: "discarded"
}

const dropDownValues : {[key:string]: any} = {
    accepted: {name: 'accepted', translate: 'Pasar a en proceso', desc: 'Si el candidato es preseleccionado.'},
    selected: {name: 'selected', translate: 'Pasar a finalista', desc: 'Si el candidato pasa a la fase final.'}
}

class View extends Component<reactProps, reactState> {

    constructor(props: reactProps) {
        super(props);

        this.state = {
            idModalInfo: rndStr(),
            idModalQuestionary: rndStr(),
            idModalLetter: rndStr()
        }
    }

    async componentDidMount() {
        if(!this.props.fetchCandidate({id: this.props.match.params.id}))
            await this.props.fetchCandidate({id: this.props.match.params.id})
        if(!this.props.fixtures.academic_programs) // lazy
            await this.props.fetchAcademicPrograms();
    }

    componentWillUnmount() {
        this.props.clearCandidate()
    }

    renderButton = () => {
        switch (this.props.candidateReducer.candidate.status) {
            case status_const.applied:
                return <ButtonApplied
                            handleDiscard={()=>this.submitChangeStatus(status_const.discarded)}
                            handleClick={(status: string) => this.submitChangeStatus(status)}
                            initialStatus={status_const.accepted}
                        />
            case status_const.accepted:
                return  <ButtonAcepted
                            handleDiscard={()=>this.submitChangeStatus(status_const.discarded)}
                            handleClick={()=>this.submitChangeStatus(status_const.selected)}
                        />
            case status_const.selected:
                return  <ButtonSelected
                            handleDiscard={()=>this.submitChangeStatus(status_const.discarded)}
                        />
            case status_const.discarded:
                return  <ButtonDiscard
                            initialStatus={status_const.accepted}
                            handleClick={(status: string) => this.submitChangeStatus(status)}
                        />
        }
    }

    submitChangeStatus = async (newStatus: string) => {
        await this.props.changeCandidateStatus(this.props.match.params.id, newStatus)
        this.props.fetchCandidate({id: this.props.match.params.id})
    }

    render = ({candidateReducer: {candidate}}: reactProps) => {
        const haveLinks = candidate?.links.length > 0;

        return (this.props.fixtures.academic_programs && candidate ) &&
        <Fragment>
            <Helmet>
                <title>{candidate.name + ' | ILERNA'}</title>
            </Helmet>
            <CF className='max-width-980'>
                <div className='d-none sm-d-block'>
                    <span><Link className={"font-light font-14 text-info"} to='/offers'>Inicio</Link></span>
                    <span className={'p-left p-right font-light font-14 text-info'}>/</span>
                    <span><Link className={"font-light font-14 text-info"} to={`/offers/${candidate.offer.id}/applied`}>{candidate.offer.title}</Link></span>
                    <span className={'p-left p-right font-14 font-light text-info'}>/</span>
                    <span className={"font-light font-14 text-info"}>Candidato</span>
                </div>

                <Card smOnly={false} className='card m-x2-top'>
                        <R className='flex-center-y'>
                            <E className='m-r'><h1 className='font-heavy font-48 no-margin-top no-margin-bottom'>{candidate.name}</h1></E>
                        </R>
                        <R>
                            <E className={"no-margin-top no-margin-bottom"}><span>{candidate.age} años</span></E>
                        </R>

                        {candidate.academicPrograms?.map((item: any)=>{
                            return <FR className={"flex-center-y"}>
                                <E>
                                    <span className={"font-medium"}><strong>{item['academicProgram']}</strong></span>
                                    <Badge type='warning' className='light m-l'><span>{item['completion']+'%'}</span></Badge>
                                </E>
                            </FR>
                        })}

                        <FR className='flex-center-y'>
                            <E>
                                <ModalLink id={this.state.idModalInfo}><span className='t-underline font-14'>Información de contacto</span></ModalLink>
                                <InfoModal id={this.state.idModalInfo} />
                            </E>
                        </FR>
                        <FR className={'flex-center-y'}>
                            <E className={'sm-col-30 col-100'}>
                                <span>Estado: </span>
                                <span className="status-color"><strong>{statuses[this.props.candidateReducer.candidate.status]}</strong></span>
                            </E>
                            <E className='sm-col-70 col-100 flexrow flex-left sm-flex-right flex-center-y'>
                                {this.renderButton()}
                            </E>
                        </FR>
                </Card>


                <Card smOnly={false} className='card m-top'>
                        <E className={"no-margin-left"}>
                            <FR className='flex-center-y'>
                                <FR className='col-100 sm-col-70 flex-baseline-y'>
                                    {(candidate.questions?.length > 0) && <Fragment>
                                        <ModalLink id={this.state.idModalQuestionary}><span className='t-underline m-r'><strong>{t('Cuestionario de inscripción')}</strong></span></ModalLink>
                                        <QuestionaryModal id={this.state.idModalQuestionary} />
                                        {candidate.hasKillerGrade && <Badge type='warning' className='light'><span>{candidate.killerGrade}%</span></Badge>}
                                    </Fragment>}
                                    {(candidate.applicationAnswers && candidate.letter) && <span className='p-left p-right'>|</span>}
                                    {(candidate.letter) && <div className='m-top sm-no-m-top sm-m-l'>
                                        <ModalLink id={this.state.idModalLetter}> <span className='t-underline'><strong>{t('Carta de presentación')}</strong></span></ModalLink>
                                        <LetterModal id={this.state.idModalLetter}/>
                                    </div>}
                                </FR>
                                <div className='sm-col-30 col-100 translucent m-top sm-no-margin-right sm-no-m-top sm-t-right'>
                                    <span>Inscripción: </span>
                                    <span>{formatDDMMYYYY(candidate.offer.date)}</span>
                                </div>
                            </FR>
                        </E>
                </Card>
                {candidate.document &&
                    <div className='card m-top '>
                        <object data={`${window.env.JOBS_API_basePath}/pdf.js/web/viewer.html?file=${window.env.JOBS_API_basePath}/company/document/${candidate.document.id}/download`} className="iframeCandidate" type="application/pdf" width="100%" >
                            <iframe src={`${window.env.BASE_URL}/pdf.js/web/viewer.html?file=${window.env.JOBS_API_basePath}/company/document/${candidate.document.id}/download`} className="iframeCandidate" width="100%" style={{border: '1px solid white'}}>
                                <p>This browser does not support PDF!</p>
                            </iframe>
                        </object>
                    </div>
                }
                {(haveLinks && <div className='card m-top '>
                    <E>
                        {candidate.links.map((link: any, index:number) => <Fragment>
                                <C className='p-top sm-p-top p-bottom sm-p-bottom m-top m-l-half p-left'><a className={"font-medium"} href={link.url}>Perfil de {link.code} </a><i className="far fa-external-link p-left" /></C>
                                {(candidate.links.length > 0 && (candidate.links.length - 1) !== index) && <hr className="separator-xxs"/>}
                            </Fragment>
                        )}
                        <C className='m-bottom' />
                    </E>
                </div>)}

            </CF>
    </Fragment>

    }


}


const ConnectedView: any = connect(
    ({fixtures, candidateReducer}:any)=>({fixtures, candidateReducer}), {fetchAcademicPrograms, fetchCandidate, changeCandidateStatus, clearCandidate})(View as any);

export default ({test=false, ...rest}) =>
    <AppPage
        name="completa-matriculacion"
        subtitle=""
        className="max-width-980">
        <ConnectedView {...rest} />

    </AppPage>
;
